import React from "react";
import axios from "axios";

function useApiCall(endpoint, options = {}, rerenderingCondition) {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (options) {
          const response = await axios.get(endpoint, options);
          setData(response?.data?.data);
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [endpoint, rerenderingCondition]);

  return { data, loading, error };
}

export default useApiCall;
